import fontSize from "./fontSize"
import colors from "./colors"

const theme = {
    colors: colors,
    fontSize: fontSize,
    spWidth: '740px',
}

export default theme 